// Gallery captions — verbatim from the legacy index page ($record['user']
// img-description strings), in slide order.
export const GALLERY_CAPTIONS = [
  "欢迎光临随便MC~",
  "欢迎光临随便MC~",
  "就算是空岛，我也要住复式别墅！",
  "又是一个好天气",
  "这位客官，我们这儿环境优美，您是打尖还是住店？",
  "欢迎光临随便MC~",
] as const;

export const GALLERY_COUNT = 6;
